import { ca } from '@cian/analytics';

export const trackRosreestrDataShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'show_data',
  });
};
